import React from "react";

// SVG waveform with optional playback cursor (progress 0..1)
export default function Waveform({
  data,
  height = 72,
  color = "var(--brand)",
  secondary,
  secondaryColor = "#a1a1aa",
  progress,
  onSeek,
}) {
  if (!data || !data.length) {
    return <div className="h-[72px] rounded-lg bg-white/[0.03]" />;
  }
  const width = 1000;
  const midY = height / 2;
  const bar = width / data.length;
  const hasProgress = typeof progress === "number" && progress >= 0;
  const cursorX = hasProgress ? Math.max(0, Math.min(1, progress)) * width : null;

  const handleClick = (e) => {
    if (!onSeek) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const p = (e.clientX - rect.left) / rect.width;
    onSeek(Math.max(0, Math.min(1, p)));
  };

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      onClick={handleClick}
      className={`w-full h-[72px] rounded-lg bg-white/[0.02] ${onSeek ? "cursor-pointer" : ""}`}
    >
      {secondary && secondary.length > 0 && (
        <g opacity="0.5">
          {secondary.map((p, i) => {
            const yTop = midY - (p.max || 0) * midY * 0.95;
            const yBot = midY - (p.min || 0) * midY * 0.95;
            return (
              <rect
                key={`s-${i}`}
                x={i * (width / secondary.length)}
                y={Math.min(yTop, yBot)}
                width={width / secondary.length}
                height={Math.max(1, Math.abs(yBot - yTop))}
                fill={secondaryColor}
              />
            );
          })}
        </g>
      )}
      {data.map((p, i) => {
        const yTop = midY - (p.max || 0) * midY * 0.95;
        const yBot = midY - (p.min || 0) * midY * 0.95;
        const isPast = hasProgress && i * bar < cursorX;
        return (
          <rect
            key={i}
            x={i * bar}
            y={Math.min(yTop, yBot)}
            width={bar}
            height={Math.max(1, Math.abs(yBot - yTop))}
            fill={color}
            opacity={isPast ? 1 : 0.55}
          />
        );
      })}
      {cursorX !== null && (
        <g>
          <line
            x1={cursorX}
            y1={0}
            x2={cursorX}
            y2={height}
            stroke="#fff"
            strokeWidth={1.5}
          />
          <circle cx={cursorX} cy={midY} r={3.5} fill="#fff" />
        </g>
      )}
    </svg>
  );
}
